import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SiteMasterService } from '../../../../services/site-master.service';
@Component({
  selector: 'app-md-list',
  templateUrl: './md-list.component.html',
  styleUrls: ['./md-list.component.scss']
})
export class MdListComponent implements OnInit, OnDestroy {
  protected componentDestroyed$: Subject<any> = new Subject();

  constructor(
    public service: SiteMasterService,
    protected route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.route.queryParams
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe((params) => {
        this.service.queryAll(params);
      });
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next(null);
    this.componentDestroyed$.complete();
  }
}
